/*
 * Mini cart upsell – lazy loader
 * Loads sections/mini-cart-upsell.liquid only when the mini cart is actually
 * visible to the shopper, so the upsell products are never part of the page
 * HTML that search engines crawl.
 */
(function () {
  var SECTION_ID = 'mini-cart-upsell';
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var URL = ROOT + '?section_id=' + SECTION_ID;

  /* ---------- visibility check ---------- */
  function isShown(el) {
    if (!el.isConnected) return false;
    if (el.checkVisibility) {
      if (!el.checkVisibility({ opacityProperty: true, visibilityProperty: true })) return false;
    } else if (!el.offsetParent) {
      return false;
    }
    var r = el.getBoundingClientRect();
    return r.right > 0 && r.left < window.innerWidth && r.bottom > 0 && r.top < window.innerHeight;
  }

  /* poll for ~3s, so drawer slide-in animations are covered */
  function tryLoad(el) {
    if (el.dataset.mcuState || el._mcuPolling) return;
    el._mcuPolling = true;
    var tries = 0;
    (function check() {
      if (!el.isConnected || el.dataset.mcuState) { el._mcuPolling = false; return; }
      if (isShown(el)) { el._mcuPolling = false; return load(el); }
      if (++tries < 30) setTimeout(check, 100);
      else el._mcuPolling = false;
    })();
  }

  function checkAll() {
    document.querySelectorAll('[data-mcu-lazy]').forEach(tryLoad);
  }

  /* ---------- fetch + insert ---------- */
  function load(el) {
    el.dataset.mcuState = 'loading';
    fetch(URL, { credentials: 'same-origin' })
      .then(function (res) { return res.text(); })
      .then(function (html) {
        if (!el.isConnected) return;
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var wrap = tmp.querySelector('.mcu_wrap');
        if (!wrap) { el.dataset.mcuState = 'empty'; return; }
        el.innerHTML = '';
        // move the <style> along with the markup
        tmp.querySelectorAll('style').forEach(function (s) { el.appendChild(s); });
        el.appendChild(wrap);
        el.dataset.mcuState = 'done';
        initSlider(wrap);
      })
      .catch(function () { delete el.dataset.mcuState; });
  }

  /* ---------- slider (same behaviour as before) ---------- */
  function initSlider(root) {
    var track  = root.querySelector('.mcu_track');
    var dotsEl = root.querySelector('.mcu_dots');
    if (!track || !dotsEl) return;

    var cards = Array.from(track.querySelectorAll('.mcu_card'));
    if (!cards.length) { root.style.display = 'none'; return; }

    // shuffle
    for (var i = cards.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var t = cards[i]; cards[i] = cards[j]; cards[j] = t;
    }
    cards.forEach(function (c) { track.appendChild(c); });

    var total = cards.length, current = 0, timer = null;
    var dotCount = Math.min(10, total);
    var nav = root.querySelector('.mcu_nav');
    if (total < 2 && nav) nav.style.display = 'none';

    for (var d = 0; d < dotCount; d++) {
      var dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'mcu_dot' + (d === 0 ? ' active' : '');
      dot.dataset.idx = d;
      dot.setAttribute('aria-label', 'Slide ' + (d + 1));
      dot.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();
        goTo(Math.round((this.dataset.idx / Math.max(dotCount - 1, 1)) * (total - 1)));
        reset();
      });
      dotsEl.appendChild(dot);
    }

    function goTo(n) {
      current = ((n % total) + total) % total;
      track.style.transform = 'translateX(-' + (current * 100) + '%)';
      var dotIndex = Math.round((current / Math.max(total - 1, 1)) * (dotCount - 1));
      dotsEl.querySelectorAll('.mcu_dot').forEach(function (el, k) {
        el.classList.toggle('active', k === dotIndex);
      });
    }

    function reset() {
      clearInterval(timer);
      if (total < 2) return;
      timer = setInterval(function () {
        if (!root.isConnected) return clearInterval(timer); // mini cart was re-rendered
        goTo(current + 1);
      }, 3500);
    }

    var prev = root.querySelector('.mcu_arrow--prev');
    var next = root.querySelector('.mcu_arrow--next');
    if (prev) prev.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); goTo(current - 1); reset(); });
    if (next) next.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); goTo(current + 1); reset(); });

    var sx = 0;
    track.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
    track.addEventListener('touchend', function (e) {
      var dx = sx - e.changedTouches[0].clientX;
      if (Math.abs(dx) > 40) { goTo(current + (dx > 0 ? 1 : -1)); reset(); }
    }, { passive: true });

    // quick view (same ghost-link trick as the original)
    root.querySelectorAll('.js_add_qv').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();
        var ghost = document.createElement('a');
        ghost.href = this.getAttribute('href');
        ghost.setAttribute('data-id', this.getAttribute('data-id'));
        ghost.setAttribute('data-handle', this.getAttribute('data-handle'));
        ghost.className = 'js_add_qv';
        ghost.style.cssText = 'position:fixed;opacity:0;pointer-events:none;top:0;left:0;width:1px;height:1px;';
        document.body.appendChild(ghost);
        ghost.click();
        setTimeout(function () { ghost.parentNode && ghost.parentNode.removeChild(ghost); }, 300);
      });
    });

    reset();
  }

  /* ---------- triggers ---------- */
  // 1. any click (opening the cart, add to cart, etc.)
  document.addEventListener('click', function () { setTimeout(checkAll, 50); }, true);

  // 2. mini cart re-rendered by the theme after a cart change -> new empty placeholder
  new MutationObserver(function (muts) {
    for (var i = 0; i < muts.length; i++) {
      if (muts[i].addedNodes.length) { checkAll(); break; }
    }
  }).observe(document.body, { childList: true, subtree: true });

  // 3. cart page / cart already open on load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', checkAll);
  } else {
    checkAll();
  }
})();
